import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { trackEvent } from '@services/analytics.service';

import './course-completion.styl'

function CourseCompletion() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const locationPath = location.pathname.split('/')
  const moduleId = Number(locationPath[3])

  useEffect(() => {
    trackEvent(`module_${moduleId}_completed`);
  }, [moduleId]);

  return (
    <div className="course-completion">
      <h2>{t('Congratulations!')}</h2>
      <p className="course-completion__text">
        {t('You completed module')} 
        {' '}
        <span>{moduleId}</span>
      </p>
      <Button
        onClick={() => navigate('/learn')}
        css={{
          borderRadius: '8px',
          color: 'white',
          '&:hover': {
            color: 'white',
          },
        }}
      >
        {t('Explore other modules')}
      </Button>
    </div>
  )
}

export default CourseCompletion